import { render, staticRenderFns } from "./AMATweet.vue?vue&type=template&id=18a952df&scoped=true&"
import script from "./AMATweet.vue?vue&type=script&lang=js&"
export * from "./AMATweet.vue?vue&type=script&lang=js&"
import style0 from "./AMATweet.vue?vue&type=style&index=0&id=18a952df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a952df",
  null
  
)

export default component.exports